import React, { useEffect } from "react";
import { Row, Col, Image, Button, Space } from "antd";
import { Link, useNavigate } from "react-router-dom";
import jwtDecode from "jwt-decode";

import { images, SIZES } from "~constants/index";
import BackgroundContainer from "../../components/BackgroundContainer/BackgroundContainer";

function LandingPage() {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      const { loginAs } = jwtDecode(token);
      navigate(`/v2/${loginAs}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BackgroundContainer>
      <Row
        type="flex"
        justify="center"
        align="middle"
        style={{ minHeight: "100vh" }}
      >
        <center>
          <Col span={20}>
            <Image
              preview={false}
              src={images.gensantourismLogo}
              width={SIZES.base * 30}
            />
            <h2>TOURISM DEVELOPMENT DIVISION</h2>
            <h3>A General Santos City Tourism Website</h3>

            <Space direction="vertical" size={"middle"}>
              <Col span={24}>
                <Button type="primary" block>
                  <Link
                    to="/auth"
                    state={{
                      usertype: "Administrator",
                    }}
                  >
                    Administrator
                  </Link>
                </Button>
              </Col>
              <Col span={24}>
                <Button type="primary" block>
                  <Link to="/auth" state={{ usertype: "TRE" }}>
                    Tourism-Related Establishment (TRE)
                  </Link>
                </Button>
              </Col>
            </Space>
          </Col>
        </center>
      </Row>
    </BackgroundContainer>
  );
}

export default LandingPage;
